<v4-custom-select
  [size]="size()"
  [textItem]="textItem"
  [showTextItem]="textItem"
  (visibleChange)="visibleChange.emit($event)">
  <div class="v4-layout-dropdown !py-[20px] !px-[20px]">
    @for (item of listOfItem; track $index; let last = $last) {
      <div
        class="flex flex-row items-center justify-between"
        [ngClass]="{
          'mb-[20px]': !last
        }">
        <span>{{ item.i18nKey | translate }}</span>
        <div class="flex flex-row items-center">
          <div
            class="controller w-[20px] h-[20px] leading-none text-center rounded-full border border-solid border-[#000] cursor-pointer"
            [ngClass]="{
              'border-[#d7d7d7] text-[#d7d7d7]': item.value <= item.min
            }"
            (click)="onChangeValue(item, '-')">
            -
          </div>
          <div class="mx-[12px]">{{ item.value }}</div>
          <div
            class="controller w-[20px] h-[20px] leading-none text-center rounded-full border border-solid border-[#000] cursor-pointer"
            (click)="onChangeValue(item, '+')">
            +
          </div>
        </div>
      </div>
    }
  </div>
</v4-custom-select>
